import {
  Body,
  Controller,
  HttpCode,
  HttpStatus,
  Post,
  Req,
} from '@nestjs/common';
import { Throttle } from '@nestjs/throttler';
import { ApiOperation, ApiTags } from '@nestjs/swagger';
import { Request } from 'express';
import { ActivityService, ActivityBatchInput } from './activity.service';

@ApiTags('Activity')
@Controller('activity')
export class ActivityController {
  constructor(private readonly activityService: ActivityService) {}

  /**
   * Its own rate limit, deliberately separate from the global 20/min per IP.
   *
   * A legitimately active shopper generates activity faster than that, and this
   * endpoint must never be the thing that throttles someone out of checking
   * out. 60/min with a per-request event cap bounds the same abuse surface
   * without that side effect.
   */
  @Post()
  @Throttle({ default: { limit: 60, ttl: 60_000 } })
  @HttpCode(HttpStatus.ACCEPTED)
  @ApiOperation({
    summary: 'Record a batch of UI activity events',
    description:
      'Accepts a batch from the client-side tracker and returns 202 immediately — ' +
      'events are buffered and written off the request path.',
  })
  record(@Body() body: ActivityBatchInput, @Req() request: Request): { accepted: number } {
    return this.activityService.record(body, request);
  }
}
